
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/legal",
      function () {
        return require("private-next-pages/en/legal/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/legal"])
      });
    }
  